import { createListenerMiddleware, type Dispatch, type ListenerEffectAPI, type UnknownAction } from '@reduxjs/toolkit'
import type { RootState } from '../store'
import { appActions } from '../slices/appSlice'

const appMiddleware = createListenerMiddleware()

const effect = (_: UnknownAction, listenerApi: ListenerEffectAPI<unknown, Dispatch>) => {
  const state = listenerApi.getState() as RootState
  const userId = state.user.userId
  if (userId) {
    const appState = state.app
    const settings = {
      isUtc: appState.isUtc,
      isDarkMode: appState.isDarkMode,
      isEnglish: appState.isEnglish,
    }
    localStorage.setItem(`user-${userId}`, JSON.stringify({ ...settings }))
  }
}

appMiddleware.startListening({ actionCreator: appActions.setUtc, effect })
appMiddleware.startListening({ actionCreator: appActions.setDarkMode, effect })
appMiddleware.startListening({ actionCreator: appActions.setEnglish, effect })
export default appMiddleware
